import { useCallback } from "react";
import { INotification } from "../../store/types";
import { NotificationHandlerType } from "./use-click-handler";
import { useNavigate } from "hooks/shared-hooks/use-navigate";

export function useDocumentHook(): NotificationHandlerType {
  const navigate = useNavigate();

  return useCallback(async ({ components }: INotification) => {
    if (components.deal_id && components.section_id && components.document_id) {
      navigate({
        route: "dealDocument",
        params: { deal_id: components.deal_id, document_id: components.document_id },
        search: { section: components.section_id }
      });
    }
    if (!components.deal_id && components.document_id) {
      return navigate({
        route: "documentId",
        params: { document_id: components.document_id, tab: "general" },
        search: { id: components.document_id },
        setQueriesMethod: "replace"
      });
    }
  }, []);
}
